export default class Collection extends HTMLElement {
  constructor() {
    super()
    // Elements
    this.$productGrid = this.querySelector('[data-block="product-grid"]')
    this.$productCards = this.querySelectorAll('product-card')
    this.$viewSwitches = this.querySelectorAll('[data-toggle="layout-switch"]')
    this.$gridBanners = this.querySelectorAll('.collection-grid-banner')
    this.$pageLoading = document.querySelector('[data-block="page-loading"]')
    // State
    this.state = {
      view: this.$productGrid?.dataset.layout || 'single', // single | grid
      loading: false,
    }

    this.stateListener = null
  }

  /********** Life Cycle Methods **********/
  // This is a hook that trigger when component mount.
  connectedCallback() {
    this.$viewSwitches.forEach((elem) => elem.addEventListener('click', (event) => this.handleClickViewSwitch(event)))
    this.adjustStyles()
  }

  // This is a hook that trigger when component unmount.
  disconnectedCallback() {
    this.$viewSwitches.forEach((elem) => elem.removeEventListener('click', (event) => this.handleClickViewSwitch(event)))
  }

  /********** Setters **********/
  setState(nextState) {
    this.state = {
      ...this.state,
      ...nextState,
    }

    // When state change we trigger render method to render component with latest state
    clearTimeout(this.stateListener)
    this.stateListener = setTimeout(() => {
      this.render()
    }, 0)
  }

  /********** Handlers **********/
  handleClickViewSwitch(event) {
    let view = null

    if (typeof event === 'object') {
      const button = event.target.closest('button')
      view = button.dataset.type
    } else {
      view = event
    }

    this.setState({ loading: true })

    fetch(window.routes.cartUrl + '/update.js', {
      body: JSON.stringify({
        attributes: {
          collection_layout: view,
        },
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
      },
    }).then(() => {
      window.location.reload()
    })
  }

  render() {
    this.renderProductGrid()
    this.renderProductCard()
    this.renderLoading()
  }

  renderProductGrid() {
    switch (this.state.view) {
      case 'grid':
        this.$productGrid.classList.remove('grid-cols--1')
        this.$productGrid.classList.add('grid-cols--2')
        this.$productGrid.dataset.layout = 'grid'
        break
      case 'single':
        this.$productGrid.classList.remove('grid-cols--2')
        this.$productGrid.classList.add('grid-cols--1')
        this.$productGrid.dataset.layout = 'list'
        break
    }
  }

  renderProductCard() {
    this.$productCards.forEach((card) => {
      switch (this.state.view) {
        case 'single':
          card.classList.remove('product-card--compact')
          break
        case 'grid':
          card.classList.add('product-card--compact')
          break
      }
    })
  }

  renderLoading() {
    if (!this.$pageLoading) return
    if (this.state.loading) {
      this.$pageLoading.classList.add('page__overlay--active')
    } else {
      this.$pageLoading.classList.remove('page__overlay--active')
    }
  }

 
}
